import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Dashboard from '@/pages/Dashboard';
import SharePage from '@/pages/SharePage';
import MediaCategoryPage from '@/pages/MediaCategoryPage';
import MediaDetailPage from '@/pages/MediaDetailPage';
import Login from '@/pages/Login';
import RegisterPage from '@/pages/RegisterPage';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import Profile from '@/pages/Profile';
import StudioIntegrativo from '@/pages/StudioIntegrativo';
import TermsAndLicense from '@/pages/TermsAndLicense';
import ProtectedRoute from '@/routes/ProtectedRoute';
import { Toaster } from '@/components/ui/toaster';
import { useAuth } from '@/contexts/AuthContext';
import Layout from '@/components/layout/Layout';

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <Helmet>
        <title>MIDIAAP</title>
        <meta name="description" content="Sua plataforma de última geração para armazenamento e compartilhamento de mídia." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&display=swap" rel="stylesheet" />
      </Helmet>

      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />
        <Route path="/register" element={isAuthenticated ? <Navigate to="/dashboard" /> : <RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/share/:id" element={<SharePage />} />
        <Route path="/terms" element={<TermsAndLicense />} />
        
        {/* Rotas protegidas com Layout */}
        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/studio" element={<StudioIntegrativo />} />
          <Route path="/filter/:filterType" element={<Dashboard />} />
          <Route path="/media/:category" element={<MediaCategoryPage />} />
          <Route path="/media/item/:id" element={<MediaDetailPage />} />
          <Route path="/videos" element={<MediaCategoryPage category="video" title="Vídeos" />} />
          <Route path="/images" element={<MediaCategoryPage category="image" title="Imagens" />} />
          <Route path="/audios" element={<MediaCategoryPage category="audio" title="Áudios" />} />
          <Route path="/gifs" element={<MediaCategoryPage category="gif" title="GIFs" />} />
          <Route path="/documents" element={<MediaCategoryPage category="document" title="Documentos" />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>

      <Toaster />
    </>
  );
}

export default App;
